import React from 'react';
import { node, object } from 'prop-types';
import { components } from 'react-select';

const SelectControl = ({ children, selectProps, ...props }) => (
    <components.Control {...props}>
        {selectProps.icon}
        {children}
    </components.Control>
);

SelectControl.propTypes = {

    children: node.isRequired,
    selectProps: object
};

export default SelectControl;
